import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { selectedIdsSelector } from "./selectedIdsSelector";

export const selectedIdsExistSelector = createDraftSafeSelector(
  [selectedIdsSelector],
  (selectedIds) => {
    return !!selectedIds?.length;
  },
);
